import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const Disclaimer = () => {
  const { language } = useLanguage();
  const isEnglish = language === 'en';

  const content = {
    en: {
      title: 'Disclaimer',
      points: [
        'Shivpratap Multistate Nagari Co-op. Credit Society provides information for general guidance.',
        'We try to keep all information correct and updated.',
        'However, we do not guarantee complete accuracy at all times.',
        'The Society is not responsible for any technical errors.',
        'Members should verify details before making decisions.',
        'Financial decisions are taken at the member’s own risk.',
        'The Society is not liable for losses due to misuse of information.',
        'Website services may be temporarily unavailable at times.',
        'External links, if any, are not under our control.',
        'By using our services, you agree to this disclaimer.'
      ]
    },
    mr: {
      title: 'अस्वीकरण',
      points: [
        'Shivpratap Multistate Nagari Co-op. Credit Society provides information for general guidance.',
        'We try to keep all information correct and updated.',
        'However, we do not guarantee complete accuracy at all times.',
        'The Society is not responsible for any technical errors.',
        'Members should verify details before making decisions.',
        'Financial decisions are taken at the member’s own risk.',
        'The Society is not liable for losses due to misuse of information.',
        'Website services may be temporarily unavailable at times.',
        'External links, if any, are not under our control.',
        'By using our services, you agree to this disclaimer.'
      ]
    }
  };

  const currentContent = isEnglish ? content.en : content.mr;

  return (
    <div className="bg-gray-50 min-h-screen py-16 mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-6 sm:p-10">
            <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
              {currentContent.title}
            </h1>
          </div>
          <div className="p-6 sm:p-10">
            <ul className="space-y-6">
              {currentContent.points.map((point, index) => (
                <li key={index} className="flex gap-4">
                  <div className="mt-2 w-2 h-2 rounded-full bg-purple-500 flex-shrink-0"></div>
                  <p className="text-gray-700 leading-relaxed text-lg">{point}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
